import { render, staticRenderFns } from "./WpImage.vue?vue&type=template&id=704db534&"
import script from "./WpImage.vue?vue&type=script&lang=js&"
export * from "./WpImage.vue?vue&type=script&lang=js&"
import style0 from "./WpImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports